var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompletedOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 8,
    fill: "#E5F9EF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.397 32.5029H50.8745V46.6464H26.1875V42.1689",
    stroke: "#1F865A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9783 28.0254H46.3973V32.5659V42.1689H21.7148V37.7499",
    stroke: "#1F865A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5019 23.6064H41.9794V37.7499H17.2969V33.2724",
    stroke: "#1F865A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.812 19.1064H37.5595V33.2499H12.877V28.5024",
    stroke: "#1F865A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.812 28.5025V14.3545H8.125V28.5025H32.812ZM20.4685 16.6765C21.4084 16.6765 22.3271 16.9552 23.1086 17.4773C23.89 17.9995 24.4991 18.7417 24.8588 19.61C25.2184 20.4783 25.3125 21.4338 25.1292 22.3556C24.9458 23.2774 24.4932 24.1241 23.8287 24.7887C23.1641 25.4532 22.3174 25.9058 21.3956 26.0892C20.4738 26.2725 19.5183 26.1784 18.65 25.8188C17.7817 25.4591 17.0395 24.85 16.5174 24.0686C15.9952 23.2871 15.7165 22.3683 15.7165 21.4285C15.7165 20.1682 16.2172 18.9595 17.1083 18.0683C17.9995 17.1771 19.2082 16.6765 20.4685 16.6765V16.6765Z",
    stroke: "#1F865A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8652 22.3418C29.1759 22.3418 29.4277 22.09 29.4277 21.7793C29.4277 21.4686 29.1759 21.2168 28.8652 21.2168C28.5546 21.2168 28.3027 21.4686 28.3027 21.7793C28.3027 22.09 28.5546 22.3418 28.8652 22.3418Z",
    stroke: "#1F865A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6156 21.7785C12.6156 21.6699 12.5834 21.5638 12.5231 21.4735C12.4627 21.3832 12.377 21.3128 12.2767 21.2713C12.1764 21.2297 12.066 21.2189 11.9595 21.24C11.853 21.2612 11.7552 21.3135 11.6784 21.3903C11.6016 21.4671 11.5493 21.5649 11.5281 21.6714C11.5069 21.7779 11.5178 21.8883 11.5594 21.9886C11.6009 22.0889 11.6713 22.1746 11.7616 22.235C11.8519 22.2953 11.958 22.3275 12.0666 22.3275C12.2122 22.3275 12.3518 22.2697 12.4548 22.1667C12.5577 22.0637 12.6156 21.9241 12.6156 21.7785V21.7785Z",
    stroke: "#1F865A",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedOrders);
export default __webpack_public_path__ + "static/media/completed_orders.6365c8abd3d506d1db487e6e5362dcc2.svg";
export { ForwardRef as ReactComponent };